module.exports = __webpack_public_path__ + "img/21.0d766ce5.png";